import ApiService from "@/common/api/api.service";

//let endpoint = "Projeto";

const ABAS = {
    
    /*setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },*/

    salvar(aba, form) {
        return ApiService.post(`Projeto/${aba}`, form)
    },

    listar(aba,projetoId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`Projeto/${aba}?ProjetoId=${projetoId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscar(aba, id) {
        return ApiService.get(`Projeto/${aba}?id=${id}`);
    },

    deletar(aba, id) {
        let form = {
            id: id
        }
        return ApiService.delete(`Projeto/${aba}`, form);
    },

    download(aba, arquivoId) {
        return ApiService.downloadFile(`Projeto/${aba}`,`download-arquivo?id=${arquivoId}`);
    },
}

export default ABAS;
